import { ButtonMeuStyled, IconStyled } from './styled';

type ButtonMenuProps = {
  hasPolicy?: boolean;
  onClick: () => void;
};

export const ButtonMenu = ({ onClick }: ButtonMenuProps) => {
  return (
    <ButtonMeuStyled onClick={onClick} aria-label="Burger Menu Button">
      <IconStyled name="burger" />
    </ButtonMeuStyled>
  );
};
